import script from "./FollowDay.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowDay.vue?vue&type=script&setup=true&lang=js"

import "./FollowDay.vue?vue&type=style&index=0&id=0cc30d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc30d62"]])

export default __exports__